import { BiCheck } from 'react-icons/bi';
import { IoAlertCircleOutline } from 'react-icons/io5';

import type { SaveStatus } from '../../hooks/useAutoSave';

import s from './SaveStatusPill.module.scss';

interface Props {
  status: SaveStatus;
}

export default function SaveStatusPill({ status }: Props) {
  if (status === 'idle') return null;

  if (status === 'saving') {
    return (
      <span className={`${s.pill} ${s.saving}`}>
        <span className={s.spinner} aria-hidden="true" />
        <span>Saving…</span>
      </span>
    );
  }

  if (status === 'saved') {
    return (
      <span className={`${s.pill} ${s.saved}`}>
        <BiCheck className={s.icon} aria-hidden="true" />
        <span>Saved</span>
      </span>
    );
  }

  return (
    <span className={`${s.pill} ${s.error}`}>
      <IoAlertCircleOutline className={s.icon} aria-hidden="true" />
      <span>Couldn’t save</span>
    </span>
  );
}
